module.exports = __webpack_public_path__ + "img/engravingRingsize-2.1f15fa0.png";